export default "__VITE_ASSET__BZEWGG3K__"